export default __webpack_public_path__ + "static/media/CardPlanPrueba.b78e60f1.png";